import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "masterCheckbox", "printButton", "row", "selectedCount"]
  static values = { printUrl: String }

  change() {
    this.#updateMaster()
    this.#updateState()
  }

  connect() {
    this.#updateState()
  }

  print() {
    const ids = this.checkboxTargets
      .filter((cb) => cb.checked)
      .map((cb) => cb.value)

    this.#submitPrintForm(this.printUrlValue, ids)
  }

  printSingle(event) {
    const button = event.currentTarget
    this.#submitPrintForm(button.dataset.printUrl, [button.dataset.customerId])
  }

  search(e) {
    const query = e.target.value.toLowerCase().trim()
    this.rowTargets.forEach((row) => {
      const matches = !query || row.dataset.customerName.toLowerCase().includes(query)
      row.style.display = matches ? "" : "none"
    })
    this.#updateMaster()
  }

  toggle() {
    const checked = this.masterCheckboxTarget.checked
    this.#visibleCheckboxes().forEach((checkbox) => {
      checkbox.checked = checked
    })
    this.#updateState()
  }

  #submitPrintForm(url, customerIds) {
    const form = document.createElement("form")
    form.action = url
    form.method = "post"
    form.target = "_blank"

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    if (csrfToken) {
      const csrfInput = document.createElement("input")
      csrfInput.name = "authenticity_token"
      csrfInput.type = "hidden"
      csrfInput.value = csrfToken
      form.appendChild(csrfInput)
    }

    customerIds.forEach((id) => {
      const input = document.createElement("input")
      input.name = "customer_ids[]"
      input.type = "hidden"
      input.value = id
      form.appendChild(input)
    })

    document.body.appendChild(form)
    form.submit()
    document.body.removeChild(form)
  }

  #updateMaster() {
    if (!this.hasMasterCheckboxTarget) return

    const visible = this.#visibleCheckboxes()
    this.masterCheckboxTarget.checked =
      visible.length > 0 && visible.every((cb) => cb.checked)
  }

  #updateState() {
    const count = this.checkboxTargets.filter((cb) => cb.checked).length

    this.selectedCountTargets.forEach((el) => {
      el.textContent = count
    })

    if (this.hasPrintButtonTarget) {
      this.printButtonTarget.disabled = count === 0
    }
  }

  #visibleCheckboxes() {
    return this.checkboxTargets.filter((cb) => {
      const row = cb.closest("[data-email-print-target~='row']")
      return row?.style.display !== "none"
    })
  }
}
